<template>
  <div class="top">
    <h3>Honorar</h3>
    <div class="label">
      <table class="tabletop">
        <tr>
          <td class="toptop orange" colspan="2">
            <span>
              {{ data.rlv[4] > 0 ? "+ " : "- "
              }}{{
                data.rlv[4].toLocaleString("de-DE", {
                  maximumFractionDigits: 2,
                })
              }}
              %
            </span>
          </td>
        </tr>
        <tr>
          <td class="tabletopleft">
            {{
              (data.rlv[3] / 1000000).toLocaleString("de-DE", {
                maximumFractionDigits: 2,
              })
            }}
            Mio €
          </td>
          <td class="tabletopright">
            {{
              (data.rlv[2] / 1000000).toLocaleString("de-DE", {
                maximumFractionDigits: 2,
              })
            }}
            Mio €
          </td>
        </tr>
      </table>
      <!-- <div class="toptop orange">
        <span>
          {{ data.rlv[4] > 0 ? "+ " : "- "
          }}{{
            data.rlv[4].toLocaleString("de-DE", {
              maximumFractionDigits: 2,
            })
          }}
          %
        </span>
      </div>
      <div class="topleft">
        {{
          (data.rlv[3] / 1000000).toLocaleString("de-DE", {
            maximumFractionDigits: 2,
          })
        }}
        Mio €
      </div>
      <div class="topright">
        {{
          (data.rlv[2] / 1000000).toLocaleString("de-DE", {
            maximumFractionDigits: 2,
          })
        }}
        Mio €
      </div> -->
    </div>
  </div>
  <div class="bttm">
    <div class="bttmright">
      <Bar
        :chart-options="chartOptions"
        :chart-data="chartData"
        chart-id="rlvChart"
      />
    </div>
    <div class="bttmleft"></div>
  </div>
</template>

<script>
import { ref, watch } from "vue";
import ChartDataLabels from "chartjs-plugin-datalabels";
import annotationPlugin from "chartjs-plugin-annotation";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ChartDataLabels,
  annotationPlugin
);

ChartJS.defaults.font.family =
  'Calibri, Carlito, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif';
ChartJS.defaults.font.size = 14;

import { Bar } from "vue-chartjs";
import { toolTipDefault } from "@/utils/settings";
import { colors } from "@/utils/config";

export default {
  name: "HonorarRlv",
  components: { Bar },
  props: ["data", "options", "id", "quartal", "inPrint", "inDownload"],
  setup(props) {
    const chartData = ref();
    const chartOptions = {
      maintainAspectRatio: false,
      responsive: true,
      indexAxis: "x",

      plugins: {
        datalabels: {
          font: {
            size: 13,
          },
          color: function (context) {
            return context.datasetIndex == 0 ? "#fff" : colors.blue;
          },
          formatter: (value, context) => {
            return (Math.round(value * 10) / 10).toLocaleString("de-DE") + "%";
          },
        },
        legend: {
          position: "bottom",
          onClick: (e) => e.stopPropagation(),
          labels: {
            boxWidth: 15,
            boxHeight: 15,
            usePointStyle: true,
            padding: 20
          },
          title: {
            padding: 5,
            display: true,
          }
        },
        tooltip: {
          ...toolTipDefault,
          callbacks: {
            label: function (context) {
              return (
                (Math.round(context.raw * 10) / 10).toLocaleString("de-DE") +
                "%"
              );
            },
            title: function (context) {
              return context[0].datasetIndex == 0 ? "EGV" : "MGV";
            },
          },
        },
      },
      scales: {
        x: {
          stacked: true,
          grid: {
            display: false,
            drawBorder: true,
            drawOnChartArea: false,
            drawTicks: false,
          },
          ticks: {
            padding: 6,
          },
        },
        y: {
          stacked: true,
          grid: {
            display: false,
            drawBorder: false,
            drawOnChartArea: false,
            drawTicks: false,
          },
          ticks: {
            display: false,
          },
        },
      },
    };

    const updateDataset = () => {
      const topDataset = [props.data.egv[6], props.data.egv[2]];
      const btmDataset = [props.data.egv[7], props.data.egv[3]];
      const quartalAr = props.quartal.split("-");
      // const labels = [
      //   quartalAr[1] + ".Q " + (quartalAr[0] - 1),
      //   quartalAr[1] + ".Q " + quartalAr[0],
      // ];
      const labels = [
        "Q " + (quartalAr[0] - 1) + "-" + quartalAr[1],
        "Q " + quartalAr[0] + "-" + quartalAr[1],
      ];

      chartData.value = {
        datasets: [
          {
            data: topDataset,
            backgroundColor: colors.lBlue,
            label: "EGV",
          },
          {
            data: btmDataset,
            backgroundColor: colors.lOrange,
            label: "MGV",
          },
        ],
        labels: labels,
      };
    };

    watch(
      () => props.data,
      (val, prevVal) => {
        updateDataset();
      }
    );

    updateDataset();

    return {
      chartOptions,
      chartData,
    };
  },
};
</script>
